import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 101 101"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("rect", {
  width: "69",
  height: "69",
  x: "32",
  y: "16",
  fill: "#1A1A1A",
  rx: "12"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("rect", {
  width: "85",
  height: "85",
  x: "8",
  y: "8",
  fill: "#262626",
  rx: "12"
}, null, -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("rect", {
  width: "85",
  height: "101",
  fill: "#333",
  rx: "12"
}, null, -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("path", {
  fill: "#CF0",
  "fill-rule": "evenodd",
  d: "M30.5 50.5a4 4 0 1 1-8 0 4 4 0 0 1 8 0m16 0a4 4 0 1 1-8 0 4 4 0 0 1 8 0m12 4a4 4 0 1 0 0-8 4 4 0 0 0 0 8",
  "clip-rule": "evenodd"
}, null, -1)
const _hoisted_6 = [
  _hoisted_2,
  _hoisted_3,
  _hoisted_4,
  _hoisted_5
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_6]))
}
export default { render: render }